import { Link } from "react-router-dom";

export default function LinkBox({text, value, bgColorClass, icon, route, routeText}){



    return (

        <div className={["small-box", bgColorClass].join(" ")}>
            <div className="inner">
                <h4>{value}</h4>

                <p>{text}</p>
            </div>
            <div className="icon">
                <i className={icon}></i>
            </div>
            <Link to={route} className="small-box-footer">{routeText} <i class="fas fa-arrow-circle-right"></i></Link>
        </div>
    );


}